import { render, staticRenderFns } from "./ReportsPackages.vue?vue&type=template&id=0586cb80&"
import script from "./ReportsPackages.vue?vue&type=script&lang=js&"
export * from "./ReportsPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports